declare namespace $ {

	type $mol_view__sub_shm_hitalama_process_logs_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_logs_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_logs_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_process_logs_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_logs['rows'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $shm_hitalama_process_logs_row__process_shm_hitalama_process_logs_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_logs['process'] >
		,
		ReturnType< $shm_hitalama_process_logs_row['process'] >
	>
	export class $shm_hitalama_process_logs extends $mol_view {
		Title( ): $mol_view
		Head( ): $mol_view
		Empty( ): $mol_view
		empty_visible( ): readonly(any)[]
		rows( ): readonly(any)[]
		List( ): $mol_list
		process( id: any): any
		sub( ): readonly(any)[]
		Row( id: any): $shm_hitalama_process_logs_row
	}
	
}

//# sourceMappingURL=logs.view.tree.d.ts.map